import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Remove server-injected SEO tags (title/description/canonical marked
// data-seo-ssr) once react-helmet-async has mounted its own managed versions,
// so JS-rendering crawlers see a single, canonical set of tags.
if (typeof document !== "undefined") {
  setTimeout(() => {
    document
      .querySelectorAll("head [data-seo-ssr]")
      .forEach((el) => el.parentNode && el.parentNode.removeChild(el));
  }, 400);
}
